import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { createResponsiveStateReducer } from 'redux-responsive';

import authReducer from '@reducers/auth';
import caseClaimsReducer from '@reducers/caseClaims';
import caseDetailsReducer from '@reducers/caseDetails';
import caseDocketsReducer from '@reducers/caseDockets';
import caseMenuReducer from '@reducers/caseMenu';
import casePreviewReducer from '@reducers/casePreview';
import casesReducer from '@reducers/cases';
import contactReducer from '@reducers/contact';
import claimDetailsReducer from '@reducers/claimDetails';
import importantDatesReducer from '@reducers/importantDates';
import loadingModalReducer from '@reducers/loadingModal';
import loginMenuReducer from '@reducers/loginMenu';
import sideMenuReducer from '@reducers/sideMenu';
import snackBarReducer from '@reducers/snackBar';
import inquiryReducer from '@reducers/inquiry';

export default combineReducers({
  auth: authReducer,
  browser: createResponsiveStateReducer({
    desktopMedium: 1919,
    desktopSmall: 1365,
    mobile: 767,
    tablet: 1023,
  }),
  caseClaims: caseClaimsReducer,
  caseDetails: caseDetailsReducer,
  caseDockets: caseDocketsReducer,
  caseMenu: caseMenuReducer,
  casePreview: casePreviewReducer,
  cases: casesReducer,
  contact: contactReducer,
  claimDetails: claimDetailsReducer,
  form: formReducer,
  importantDates: importantDatesReducer,
  loadingModal: loadingModalReducer,
  loginMenu: loginMenuReducer,
  sideMenu: sideMenuReducer,
  snackBar: snackBarReducer,
  inquiry: inquiryReducer,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js